module.exports = __webpack_public_path__ + "img/card-mgye.d74e3402.png";